import React from 'react';
import styled from 'styled-components';

import { Sidebar } from '../layout/sidebar';

import MainRouter from './mainRouter';
import { Content } from '../layout';

const PageContainer = styled.div`
  display: flex;
  flex-grow: 1;
  min-height: 100% !important;
  max-height: 100% !important;
  position: relative;
  flex-direction: column;
  overflow: hidden;
  z-index: 1;

  @media screen and (min-width: 992px) {
    flex-direction: row;
  }
`;

export { createRouteMap } from './route-config';

const Main = () => {
  return (
    <PageContainer>
      <div style={{ flexShrink: 0 }}>
        <Sidebar />
      </div>
      <Content>
        <MainRouter />
      </Content>
    </PageContainer>
  );
};

export default Main;
